import React, { Component } from 'react';
import ChatBarOptions from './chatBarOptionsComponent';
import ChatBarInputField from './chatBarInputField';
import $ from 'jquery'
import GlobalStoreService from "../../../services/global-store.service";
import PlatformType from '../../../enums/PlatformType';
import IdleTimeoutService from "../../../services/idle-timeout.service";
import { globalConstants } from "../../../constants/globalConstants";
import { calculateOptionsPosition } from '../../../services/UICalculations.service'
import UserActionClass from '../../../objectClasses/user-action-class'
import UserActionType from '../../../enums/UserActionType'
import UtilService from '../../../services/util.service'
import ScenarioType from '../../../enums/scenario-type';
import TrackingPlatform from '../../../enums/TrackingPlatform';


class ChatBar extends Component {

    constructor(props) {
        super(props)
        this.state = {
            bottom_bar_options_visible: false,
            field_type: props.fieldType,
            search_suggestions: {},
            input_search_value: '',
            showNumbersToSwitchBot: this.props.showNumbersToSwitchBot
        }
        this.inputBoxRef = React.createRef();
    }

    componentWillReceiveProps(new_props) {
        if (this.state.field_type !== new_props.fieldType) {
            this.setState({
                field_type: new_props.fieldType
            })
        }
        if (this.state.showNumbersToSwitchBot !== new_props.showNumbersToSwitchBot) {
            if (new_props.showNumbersToSwitchBot) {
                this.props.scrollToBottom()
                this.setState({ bottom_bar_options_visible: true })
            }
            this.setState({ showNumbersToSwitchBot: new_props.showNumbersToSwitchBot })
        }
        if (new_props.responseAwaiting) {
            this.setState({ bottom_bar_options_visible: false })
            this.clearInputFieldAndSuggestions()
        }
    }

    renderSearchSuggestions = () => {

        IdleTimeoutService.updateIdleState();
        let list = [];
        let suggestions = []
        if (this.state.search_suggestions && Object.keys(this.state.search_suggestions).length > 0) {
            suggestions = Object.keys(this.state.search_suggestions).map((item, index) => {
                return this.getSnsObject(item, index)
            })
        }
        suggestions && suggestions.map((snsobject, index) => {
            list.push(<li key={index} onMouseDown={(e) => { this.handleUserInput(snsobject) }}>{this.getHighlightedSnsHtml(snsobject.longKey)}</li>)
        })
        return list.map((item, index) => <div key={index}>{item}</div>)
    }

    getHighlightedSnsHtml = (sns) => {
        let userInput = this.state.input_search_value;
        var index = sns.toLowerCase().indexOf(userInput.toLowerCase());
        if (index !== -1) {
            return <p>{sns.substring(0, index)}<span>{sns.substring(index, index + userInput.length)}</span>{sns.substring(index + userInput.length)}</p>
        }
        return <p>{sns}</p>
    }

    getSnsObject = (key, snsIndex) => {

        if (this.state.field_type === globalConstants.INPUT_FIELD_TYPES.PLACE) {
            let item = this.state.search_suggestions[key]
            return {
                shortKey: item.terms[item.terms.length - 1].value.trim(),
                longKey: item.description
            }
        }
        else {
            let scenarioResponse
            let scenario
            let scenarioStrategy
            if (this.state.search_suggestions[key] && this.state.search_suggestions[key].scenario) {
                scenario = this.state.search_suggestions[key]
                if (this.state.search_suggestions[key].scenario.scenarioStrategy) {
                    scenarioStrategy = this.state.search_suggestions[key].scenario.scenarioStrategy
                    if (scenarioStrategy === ScenarioType.FAQScenario) {
                        scenarioResponse = UtilService.getCategoryFaqPlatformResponse(this.state.search_suggestions[key])
                    }
                }

            }
            return {
                longKey: key,
                scenarioResponse,
                shortKey: key,
                scenario: scenario,
                scenarioStrategy
            }
        }
    }

    componentDidMount() {
        const platformType = GlobalStoreService.get("platformType");
        //only for old version
        if (window.MyAirtelAppReact && platformType === PlatformType.ANDROID) {
            this.inputBoxRef.current.addEventListener("focus", (e) => {
                this.handleKeyBoardInApp(true);
                if (this.state.bottom_bar_options_visible) {
                    this.closeOptions();
                }
                this.props.scrollToBottom();
            });
            this.inputBoxRef.current.addEventListener("blur", (e) => {
                this.handleKeyBoardInApp(false);
            });
        }
        else {
            this.inputBoxRef.current.addEventListener("focus", (e) => {
                if (this.state.bottom_bar_options_visible) {
                    this.closeOptions();
                }
                let platformType = UtilService.getPlatformTypeForTracking();
                if (platformType === TrackingPlatform.IOS_WEBVIEW) {
                    document.getElementById('messagesEnd').scrollIntoView({ behavior: "instant", block: "end" });
                }
                else {
                    this.props.scrollToBottom();
                }
            });
        }
        window.addEventListener("resize", (e) => {
            this.props.scrollToBottom();
        });

        document.getElementById("user_input")
            .addEventListener("keyup", (event) => {
                event.preventDefault();
                if (event.keyCode === 13 && this.state.field_type === globalConstants.INPUT_FIELD_TYPES.CHAT) {
                    this.handleUserInput();
                }
            });
    }

    handleKeyBoardInApp = (isFocussed) => {
        IdleTimeoutService.updateIdleState();
        if (isFocussed) {
            $("#main").addClass("shift-up");
            $("#bottom-bar-id").addClass("border-bottom-bar");
        } else {
            $("#main").removeClass("shift-up");
            $("#bottom-bar-id").removeClass("border-bottom-bar");
        }
    }


    setSearchSuggestions = (search_suggestions_obj, input_search_value) => {
        IdleTimeoutService.updateIdleState();
        this.setState({ search_suggestions: search_suggestions_obj })
    };
    setInputTextState = (input) => {
        IdleTimeoutService.updateIdleState();
        if (this.state.bottom_bar_options_visible) {
            this.setState({ input_search_value: input, bottom_bar_options_visible: false })
        }
        else {
            this.setState({ input_search_value: input })
        }
    }

    handleUserInput = (snsobject) => {
        // console.log(snsobject)
        let userActionType = snsobject ? this.state.field_type === globalConstants.INPUT_FIELD_TYPES.PLACE ? UserActionType.COUNTRY_SELECT : UserActionType.SNS_CLICKED : UserActionType.CHAT_TEXT_ENTER
        let userInput = this.state.input_search_value
        IdleTimeoutService.updateIdleState();
        $('#user_submit_button').removeClass('active')
        if (!this.props.disableUserSubmit && userInput !== '') {

            this.props.handleUserAction(new UserActionClass(userActionType, this.state.input_search_value, snsobject))


            //--- clear input field and suggestions
            $('#user_input').val(null);
            this.setState({ search_suggestions: {}, bottom_bar_options_visible: false, input_search_value: '' });
        }
    };


    componentDidUpdate() {
        if (this.state.search_suggestions && Object.keys(this.state.search_suggestions).length !== 0 && this.state.input_search_value === '') {
            this.setState({ search_suggestions: {} });
        }
        if (document.getElementById('main') && document.getElementById('main').scrollHeight > 60) {
            if (document.getElementById('options_bar_position_id')) {
                if (!this.state.bottom_bar_options_visible) {

                    calculateOptionsPosition()
                }
                else {
                    document.getElementById('options_bar_position_id').style.position = 'static'

                }
            }
        }
    }
    clearInputFieldAndSuggestions = () => {
        $('#user_input').val(null);
        this.setState({ search_suggestions: {}, input_search_value: '' })
    }

    closeOptions = () => {
        IdleTimeoutService.updateIdleState();
        this.setState({ bottom_bar_options_visible: false, showNumbersToSwitchBot: false })
        // this.props.disableNumbersToSwitchBot()
    }

    onCategoryOptionClick = (option_obj) => {
        IdleTimeoutService.updateIdleState();
        $('#user_input').val(null);
        $('#user_submit_button').removeClass('active')
        this.setState({ search_suggestions: {}, bottom_bar_options_visible: false, input_search_value: '' });

        let userActionObject = this.createUserActionObject(option_obj)
        this.props.handleUserAction(userActionObject)
        // this.props.onCategoryOptionClick(option_obj)
    }

    createUserActionObject = (optionObj) => {
        let platformTypeResponse
        let scenarioStrategy
        let scenarioObject
        if (optionObj.scenario && optionObj.scenario.scenarioStrategy && optionObj.scenario.scenarioStrategy === ScenarioType.FAQScenario) {
            if (optionObj[GlobalStoreService.get('platformType').toLowerCase()] !== null) {
                platformTypeResponse = UtilService.getCategoryFaqPlatformResponse(optionObj)
                scenarioStrategy = ScenarioType.FAQScenario
            }

        }
        else if (optionObj.scenario && optionObj.scenario.scenarioStrategy && optionObj.scenario.scenarioStrategy === ScenarioType.DTScenario) {
            scenarioObject = optionObj.scenario
            scenarioStrategy = ScenarioType.DTScenario
        }
        let catgegoryObject = {
            scenarioTitle: optionObj.scenario_description_en,
            scenarioResponse: platformTypeResponse,
            scenarioStrategy,
            scenario: scenarioObject
        }

        return new UserActionClass(UserActionType.CATEGORY_OPTION_CLICKED, null, null, catgegoryObject)
    }



    toggleOptionsButtonClick = () => {
        if (this.state.bottom_bar_options_visible) {
            this.closeOptions();
        }
        else {
            IdleTimeoutService.updateIdleState();
            this.props.scrollToBottom()
            this.setState({ bottom_bar_options_visible: true })
        }
    }

    render() {
        let { onSwitchNumber, showPopup } = this.props

        return (
            <div id="bottom-bar-id" className="bottom-bar" style={{ height: 'auto', position: 'static' }}>
                {this.state.search_suggestions && Object.keys(this.state.search_suggestions).length > 0 &&
                    <div className="suggestive-search show">
                        <ul>
                            {!this.state.bottom_bar_options_visible && this.renderSearchSuggestions()}
                        </ul>
                    </div>}
                <span>
                    <span className="" id="animid">
                        <a href="javascript:void(0)"
                            className={(this.state.bottom_bar_options_visible) ? `bottom-menu${GlobalStoreService.get('platformType') === PlatformType.WEB ? '-red' : ''} cross` : `bottom-menu${GlobalStoreService.get('platformType') === PlatformType.WEB ? '-red' : ''}`}
                            onClick={() => { this.toggleOptionsButtonClick() }} />
                        {ChatBarInputField({
                            setSearchSuggestions: this.setSearchSuggestions,
                            field_type: this.state.field_type,
                            handleUserInput: this.handleUserInput,
                            disable_field: (this.props.disableUserSubmit || this.props.disableInputField),
                            setInputTextState: this.setInputTextState,
                            inputBoxRef: this.inputBoxRef
                        })}
                    </span>
                    {this.state.bottom_bar_options_visible &&
                        <ChatBarOptions onCategoryOptionClick={this.onCategoryOptionClick}
                            clearInputFieldAndSuggestions={this.clearInputFieldAndSuggestions}
                            onSwitchNumber={onSwitchNumber}
                            closeOptions={this.closeOptions}
                            showNumbersToSwitchBot={this.state.showNumbersToSwitchBot}
                            showPopup={showPopup}
                        />}
                </span>
            </div>
        );
    }
}

export default ChatBar;



// WEBPACK FOOTER //
// ./src/components/bottom-components/default-chat-bar-components/chatBarComponent.js